import {Controller} from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    this.initTooltips(this.element)
    this.handleFrameLoad = (event) => this.initTooltips(event.target)
    this.handleBeforeFrameRender = (event) => {
      if (!window.$)
        return
      const frame = event.target || document
      this.constructor.disposeTooltips(frame)
    }

    document.addEventListener('turbo:frame-load', this.handleFrameLoad)
    document.addEventListener('turbo:before-frame-render', this.handleBeforeFrameRender)
  }

  disconnect() {
    document.removeEventListener('turbo:frame-load', this.handleFrameLoad)
    document.removeEventListener('turbo:before-frame-render', this.handleBeforeFrameRender)
  }

  initTooltips(root) {
    if (!window.$)
      return

    const target = root || this.element || document
    window.$(target).find('[data-toggle="tooltip"]').tooltip({
      placement: 'auto',
      boundary: 'viewport',
    })
  }

  static disposeTooltips(frame) {
    if (!window.$)
      return

    // dispose any tooltip instances inside the frame about to be replaced
    window.$(frame).find('[data-toggle="tooltip"]').tooltip('dispose')
    // remove any leftover tooltip DOM nodes appended to body
    window.$('.tooltip').remove()
  }
}
